<p-dialog modal=true header="Liberar/Finalizar Anúncio" [(visible)]="exibirModalLiberarAnuncio" [width]="800">

    <p-fieldset *ngIf="anuncio" [legend]="'Selecione o motivo da liberação do anúncio nº '+ anuncio.id+':'" [style]="{'margin-top':'10px'}">
      <div class="ui-g-12">
        <p-radioButton name="tipoTic" class="flexCenter" value="1" (onClick)="onTipoTicChange(1)" [(ngModel)]="anuncioTipoTic" label="Este anúncio cumpriu os requisitos da Lei nº 14.479, de 21 de dezembro
        de 2022, e foi liberado pelo doador para manifestação de interesse."
          inputId="bemtic-14.479/2022-A"></p-radioButton>
      </div>
      <div class="ui-g-12">
        <p-radioButton name="tipoTic" class="flexCenter" value="2" (onClick)="onTipoTicChange(2)" [(ngModel)]="anuncioTipoTic" label="Os bens contidos neste anúncio não fazem parte do escopo da Lei nº 14.479, de 21 de dezembro de 2022, e foram
          liberados pelo doador para manifestação de interesse."
          inputId="bemtic-14.479/2022-B"></p-radioButton>
      </div>
    </p-fieldset>
     <p-fieldset *ngIf="anuncio" [legend]="'Ou finalize o anúncio nº '+ anuncio.id+' pelo seguinte motivo:' " [style]="{'margin-top':'10px'}">
      <div class="ui-g-12">
        <p-radioButton name="tipoTic" class="flexCenter" value="true" (onClick)="finalizarAnuncio = true" [(ngModel)]="finalizarAnuncio" label="Os bens deste anúncio foram destinados ao Programa Computadores para Inclusão, nos termos da Lei nº 14.479, de 21 de dezembro de 2022. Por esse motivo, o anúncio foi finalizado."
          inputId="finalizarAnuncio"></p-radioButton>
      </div>
     </p-fieldset>
      <p-footer>
      <div class="buttons text-right">
        <button type="button" pButton label="Cancelar" class="ui-button-secondary" (click)="onCancelar()"></button>
        <button type="submit" pButton label="Confirmar" class="ui-button-success" (click)="onConfirmar()" [disabled]="!anuncioTipoTic && !finalizarAnuncio"></button>
      </div>
    </p-footer>
</p-dialog>
<!-- [(ngModel)]="anuncioTipoTic"
               [ngModelOptions]="{standalone: true}" -->
